import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';

import { HeaderComponent } from './header/header.component';
import { EnergyComponent } from './energy/energy.component';
import { ProductivityComponent } from './productivity/productivity.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { RightAsideEnergyComponent } from './energy/right-aside-energy/right-aside-energy.component';
//import { RightAsideComponent } from './productivity/right-aside/right-aside.component';
import { LeftThoughRightComponent } from './leftAside/left-though-right/left-though-right.component';
//import {LeftThoughRightComponent as LeftThoughRightComponentp} from './productivity/left-though-right/left-though-right.component';
import { LeftAsideComponent } from './leftAside/leftAside.component';
import { LeftAsideService } from './leftAside/left-aside.service';
import { LeftThoughRightService } from './leftAside/left-though-right.service';

import { AppDataServiceService } from './app-data-service.service';
import { LoaderService } from './loader/loader.service';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { LoaderInterceptor } from './loader/loader. interceptor';
import { LoaderComponent } from './loader/loader.component';
import { InteractionService } from './interaction.service';
import { FooterComponent } from './footer/footer/footer.component';
import { AppRoutingModule } from './app-routing.module';
import { AllDeviceGreaphComponent } from './bottom_menu/all-device-greaph/all-device-greaph.component';
import { BiReportComponent } from './bottom_menu/bi-report/bi-report.component';
import { SafePipePipe } from './safe-pipe.pipe';
import { SafePipe } from './safe.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import {  MatDatepickerModule, MatNativeDateModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatRippleModule} from '@angular/material';
import {NgbModule,NgbDate} from '@ng-bootstrap/ng-bootstrap';

import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';




//import { RequestResetComponent } from './Auth/password/request-reset/request-reset.component';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';

import { LoginComponent } from './Auth/login/login.component';
import { SignupComponent } from './Auth/signup/signup.component';
import { RequestResetComponent } from './Auth/password/request-reset/request-reset.component';
import { ResponseResetComponent } from './Auth/password/response-reset/response-reset.component';
import { SighUpFormComponent } from './Auth/sigh-up-form/sigh-up-form.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';





@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    EnergyComponent,
    ProductivityComponent,
    SidenavComponent,
    RightAsideEnergyComponent,
    //RightAsideComponent,

    LeftAsideComponent,
    LoaderComponent,
    FooterComponent,
    AllDeviceGreaphComponent,
    BiReportComponent,
    SafePipePipe,
    SafePipe,
    LoginComponent,
   DashboardComponent,
   SignupComponent,
   RequestResetComponent,
   ResponseResetComponent,
   SighUpFormComponent,
   LeftThoughRightComponent,
   //LeftThoughRightComponentp
   //ResetComponent
 ],
  imports: [
    NgbModule,
    BrowserModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    MatSliderModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,    
    MatDatepickerModule,       
    MatNativeDateModule,
    SnotifyModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    
  ],
  
  providers: [
    InteractionService,LeftAsideService,LeftThoughRightService,AppDataServiceService,LoaderService,{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
      { provide: 'SnotifyToastConfig', useValue: ToastDefaults},
       SnotifyService],
  
  bootstrap: [AppComponent]
})
export class AppModule { }
